/**
 * Collection browse — sort, venue scoping of the grid, and navigation-context
 * (#from/&zone) preservation onto product links.
 *
 *  - Sort form: auto-submit on change (desktop select, mobile popup list).
 *  - Keep #from/&zone across sorting (carried on the GET form's action fragment) and onto
 *    product links, so the PDP breadcrumb trail survives.
 *  - The category tree lives in the sidebar and has its own script (assets/cat-sidebar.js).
 *
 * There are no product filters — Search & Discovery was dropped 2026-07-31.
 *
 * The context lives in the URL FRAGMENT, not the query string. It is read here and in
 * breadcrumb-context.js and never by the server, so a fragment carries it just as well —
 * and it does not mint a crawlable URL per venue/zone combination, which as query params
 * produced ~534 clone URLs. See theme/docs/plans/gsc-coverage-2026-07.md.
 */
(function () {
  var params = new URLSearchParams(location.hash.slice(1));
  var rawFrom = params.get('from');
  var rawZone = params.get('zone');
  var from = rawFrom;
  var zone = rawZone;

  // Complete the context from the page's own placement (sections/collection-browse.liquid
  // stamps it on the section), so a visitor who arrived without a fragment — direct link,
  // search result — still hands a full trail to the PDP breadcrumb. The fragment they DID
  // arrive with keeps precedence: a group or leaf recurs under several venues.
  var section = document.querySelector('.collection-browse[data-canon-venue]');
  if (section) {
    if (!from) from = section.getAttribute('data-canon-venue') || '';
    if (!zone && (!rawFrom || rawFrom === from)) zone = section.getAttribute('data-canon-zone') || '';
  }

  var ctxPairs = [];
  if (from) ctxPairs.push(['from', from]);
  if (zone) ctxPairs.push(['zone', zone]);
  var ctxStr = ctxPairs.map(function (p) {
    return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
  }).join('&');

  // Append the context as a fragment. A link that already carries one is left alone.
  function appendCtx(a) {
    if (!ctxStr) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('#') !== -1) return;
    a.setAttribute('href', href + '#' + ctxStr);
  }

  // ── Sort form: auto-submit + context preservation ───────────────────────
  var sortForm = document.querySelector('[data-collection-sort]');

  // A GET form: the browser replaces the action URL's QUERY with the form data and leaves
  // its FRAGMENT untouched, so parking the context on the action survives the navigation.
  if (sortForm && ctxStr) {
    var action = sortForm.getAttribute('action') || location.pathname;
    sortForm.setAttribute('action', action.split('#')[0] + '#' + ctxStr);
  }

  if (sortForm) {
    sortForm.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.collection-browse__sort-select')) sortForm.submit();
    });

    // Mobile: icon button toggles a popup list; picking an option submits.
    var sortToggle = sortForm.querySelector('[data-sort-toggle]');
    var sortMenu = sortForm.querySelector('[data-sort-menu]');
    var sortSelect = sortForm.querySelector('.collection-browse__sort-select');
    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = sortMenu.hasAttribute('hidden');
        if (willOpen) sortMenu.removeAttribute('hidden'); else sortMenu.setAttribute('hidden', '');
        sortToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
      sortMenu.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-sort-value]');
        if (!opt) return;
        if (sortSelect) sortSelect.value = opt.getAttribute('data-sort-value');
        sortForm.submit();
      });
      document.addEventListener('click', function (e) {
        if (!sortMenu.hasAttribute('hidden') && !sortForm.contains(e.target)) {
          sortMenu.setAttribute('hidden', '');
          sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  // ── Venue scoping of the grid ───────────────────────────────────────────
  // A leaf (or group) collection is one Shopify collection shared by every venue it hangs
  // under, and its rule is category:/xref: only — so Home > Garden bar > Outdoor kitchens
  // also listed a restaurant-only fit-out. Zones and venues are venue-scoped on the server;
  // below them only the fragment knows the venue, so hide the cards whose data-venues
  // (snippets/product-card.liquid) lack it.
  //
  // Only on an explicit #from: the canonical venue is a guess, and a direct visit must keep
  // showing the whole collection. And never down to nothing.
  if (rawFrom) {
    var cards = document.querySelectorAll('.collection-browse__grid > .product-card');
    var foreign = Array.prototype.filter.call(cards, function (card) {
      return (' ' + (card.getAttribute('data-venues') || '') + ' ').indexOf(' ' + rawFrom + ' ') === -1;
    });
    if (foreign.length && foreign.length < cards.length) {
      foreign.forEach(function (card) { card.style.display = 'none'; });
      var countEl = document.querySelector('.collection-browse__count[data-count]');
      var total = countEl && countEl.getAttribute('data-count');
      if (total) countEl.textContent = countEl.textContent.replace(total, String(total - foreign.length));
    }
  }

  // ── Product links inherit the navigation context for the PDP breadcrumb ──
  if (ctxStr) {
    document.querySelectorAll('.product-card__link').forEach(appendCtx);
  }

  // ── Same-page context switch ────────────────────────────────────────────
  // A link to the page you are already on with another context only fires hashchange;
  // reload so the sidebar and the breadcrumb are rebuilt for it. Non-context fragments
  // (#product-reviews and friends) are ignored.
  window.addEventListener('hashchange', function () {
    var next = new URLSearchParams(location.hash.slice(1));
    var nextFrom = next.get('from');
    var nextZone = next.get('zone');
    if (!nextFrom && !nextZone) return;
    if (nextFrom === rawFrom && nextZone === rawZone) return;
    location.reload();
  });
})();
